// to add expand/collapse in about delivery
        document.addEventListener("DOMContentLoaded", function() {
            if (window.innerWidth <= 768) {
                document.querySelectorAll(".info-box h3").forEach(function(header) {
                    header.addEventListener("click", function() {
                        this.parentElement.classList.toggle("active");
                    });
                });
            }
        });





// --- Early removal of video in mobile and move it to bottom ---
(function() {
  var observer = new MutationObserver(function(mutations, obs) {
    var el = document.querySelector('.videoCol-gallery');
    if (el) {
      el.style.display = 'none'; // hide immediately just in case
      el.remove();               // yank it from the DOM
      window._videoColEl = el;   // store globally to reinsert later
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// --- Reinsert in correct location ---
document.addEventListener('DOMContentLoaded', function() {
  function placeVideoCol() {
    if (!window._videoColEl) return;

    var safeSticky = document.querySelector('safe-sticky.product-info');
    var productGallery = document.querySelector('product-gallery');

    if (window.innerWidth <= 768 && safeSticky) {
      if (!safeSticky.contains(window._videoColEl)) {
        safeSticky.insertBefore(window._videoColEl, safeSticky.lastChild);
      }
    } else if (productGallery) {
      if (!productGallery.contains(window._videoColEl)) {
        productGallery.appendChild(window._videoColEl);
      }
    }
    window._videoColEl.style.display = ''; // make it visible
  }

  // First placement
  placeVideoCol();

  // Update on resize
  window.addEventListener('resize', placeVideoCol);
});

// FW - Klaviyo newsletter signup tracking
window.addEventListener("klaviyoForms", function(e) {
  if (!e.detail || e.detail.type !== "submit") return;

  var metaData = e.detail.metaData || {};
  var email = metaData.email || metaData.$email || "";

  if (!email) return;

  email = email.trim().toLowerCase();

  // Prevent duplicate firing in the same browser session
  var dedupeKey = "fw_newsletter_signup_" + email;

  if (sessionStorage.getItem(dedupeKey)) return;

  sessionStorage.setItem(dedupeKey, "1");

  // Keep existing Shopify analytics event
  if (
    window.Shopify &&
    Shopify.analytics &&
    typeof Shopify.analytics.publish === "function"
  ) {
    Shopify.analytics.publish("fw:newsletter_signup", {
      user_email: email
    });
  }

  // Fire native Google Ads enhanced conversion
  if (typeof gtag === "function") {

    gtag("set", "user_data", {
      email: email
    });

    gtag("event", "conversion", {
      send_to: "AW-16898234707/o30PCIqFr5QdENOy2vk-"
    });

    console.log("FW Newsletter Signup Google Ads conversion fired");
  }
});


// FW - Shopify default newsletter tracking
(function () {

  function fireShopifyNewsletterConversion(email) {
    if (!email || typeof gtag !== "function") return;

    email = email.trim().toLowerCase();

    // Same dedupe key as Klaviyo tracking
    var dedupeKey = "fw_newsletter_signup_" + email;

    if (sessionStorage.getItem(dedupeKey)) return;

    sessionStorage.setItem(dedupeKey, "1");

    gtag("set", "user_data", {
      email: email
    });

    gtag("event", "conversion", {
      send_to: "AW-16898234707/o30PCIqFr5QdENOy2vk-"
    });

    console.log("FW Shopify Newsletter Google Ads conversion fired");
  }


  document.addEventListener("submit", function(e) {
    var form = e.target;

    if (!form || !form.querySelector) return;

    var emailInput =
      form.querySelector('input[name="contact[email]"]');

    if (!emailInput || !emailInput.value) return;

    var tagsInput =
      form.querySelector('input[name="contact[tags]"]');

    // If Shopify supplies tags, make sure it really is a newsletter form
    if (
      tagsInput &&
      tagsInput.value.toLowerCase().indexOf("newsletter") === -1
    ) {
      return;
    }

    sessionStorage.setItem(
      "fw_pending_newsletter_email",
      emailInput.value.trim().toLowerCase()
    );
  });


  function checkForNewsletterSuccess() {

    var email =
      sessionStorage.getItem("fw_pending_newsletter_email");

    if (!email) return;

    var success =
      document.querySelector(
        '.newsletter-form__message--success,' +
        '[id*="Newsletter-success"],' +
        '.newsletter-success'
      );

    if (!success) return;

    sessionStorage.removeItem(
      "fw_pending_newsletter_email"
    );

    fireShopifyNewsletterConversion(email);
  }


  // Handles normal Shopify page reload
  document.addEventListener(
    "DOMContentLoaded",
    checkForNewsletterSuccess
  );


  // Handles themes that submit the newsletter with AJAX
  var observer = new MutationObserver(function() {
    checkForNewsletterSuccess();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
